import { useId } from 'react';
import type { ReactElement } from 'react';

export interface FieldProps {
  label: string;
  /** Shown under the input in the error colour. Also marks the input invalid. */
  error?: string | null;
  hint?: string;
  /** Render prop receives the ids to wire up label/aria-describedby correctly. */
  children: (props: { id: string; describedBy?: string; invalid: boolean }) => ReactElement;
}

export function Field({ label, error, hint, children }: FieldProps) {
  const id = useId();
  const hintId = `${id}-hint`;
  const errorId = `${id}-error`;
  const describedBy = error ? errorId : hint ? hintId : undefined;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--sp-2)' }}>
      <label
        htmlFor={id}
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 'var(--fs-body-sm)',
          fontWeight: 600,
          color: 'var(--text-secondary)',
        }}
      >
        {label}
      </label>

      {children({ id, describedBy, invalid: Boolean(error) })}

      {hint && !error && (
        <span id={hintId} style={{ fontSize: 'var(--fs-caption)', color: 'var(--text-muted)' }}>
          {hint}
        </span>
      )}
      {error && (
        <span id={errorId} style={{ fontSize: 'var(--fs-caption)', color: 'var(--error)' }}>
          {error}
        </span>
      )}
    </div>
  );
}
